import { useState } from "react";
import CrudPageProcessButton from "../core/component/crud/CrudPageProcessButton";
import { Button, Checkbox, Form, Modal, Row, Select } from "antd";
import { useForm } from "antd/lib/form/Form";
import { Rules } from "../core/Rules";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";

const columns = {
  earringNo: "Küpe No",
  companyName: "İşletme Id",
  birthDay: "Yaş/Gün",
  paddock: "Padok",
  dsg: "SGS",
  sgs: "pSGS",
  gsv: "GSV",
  ts: "TS",
  state: "Durum",
  pregnancyDay: "TSGS",
  birthRemainder: "Kalan Süre",
  birthDate: "Doğum Tarihi",
  gender: "Cinsiyet",
  racial: "Irk",
  mother: "Ana Adı",
  father: "Baba Adı",
  birthWeight: "Doğum Ağırlığı",
  weaningWeight: "Sütten Kesme Ağırlığı",
  isActive: "Sürüde Mi?",
  "lastSemination.date": "Son Tohumlama Tarihi",
  "lastBirth.date": "Son Doğurma Tarihi",
  "lastSemination.usg1": "USG1",
  "lastSemination.usg2": "USG2",
} as any;

const valueMap = {
  open: "Açık",
  "non-pregnant": "Boş",
  pregnant: "Gebe",
  none: "Belirsiz",
  female: "Dişi",
  male: "Erkek",
  holstein: "HOLSTEIN",
  redholstein: "RED HOLSTEIN",
  simental: "SIMENTAL",
  montofon: "MONTOFON",
  montbeliarde: "MONTBELIARD",
  hereford: "HEREFORD",
  angus: "ANGUS",
  jersey: "JERSEY",
} as any;

const getNestedValue = (obj: any, path: string) => {
  const value = path.split(".").reduce((acc, key) => acc?.[key], obj);
  if (typeof value != "string") return value;
  if (hasValidDateFormat(value)) return moment(value).format("DD MMMM YYYY");
  return valueMap[value] ?? value;
};

const hasValidDateFormat = (str: string): boolean => {
  const dashCount = (str.match(/-/g) || []).length;
  const colonCount = (str.match(/:/g) || []).length;
  const tCount = (str.match(/T/g) || []).length;
  const plusCount = (str.match(/\+/g) || []).length;

  return dashCount === 2 && colonCount === 3 && tCount === 1 && plusCount === 1;
};

const AnimalExcelReportModal = (props: any) => {
  const [reportForm] = useForm();

  const [reportModalIsOpen, setReportModalIsOpen] = useState<boolean>(false);
  const [reportLoading, setReportLoading] = useState<boolean>(false);
  const [isDeadInclude, setIsDeadInclude] = useState<boolean>(false);

  return (
    <>
      <CrudPageProcessButton
        tooltipText="Sürü Raporu"
        icon={<>R</>}
        onClick={() => setReportModalIsOpen(true)}
      />
      <Modal
        title="Sürü Raporu"
        visible={reportModalIsOpen}
        confirmLoading={reportLoading}
        okText="Oluştur"
        cancelText="Vazgeç"
        onCancel={() => {
          setReportModalIsOpen(false);
          setReportLoading(false);
          reportForm.resetFields();
        }}
        onOk={() => {
          reportForm.validateFields().then((value) => {
            setReportLoading(true);

            let data = props.animals
              .filter((animal: any) => {
                if (!isDeadInclude) {
                  return animal.isActive === true;
                }

                return true;
              })
              .map((animal: any) => {
                // if (animal.pregnancyDay === 0 && animal.lastSemination) {
                //   animal.lastSemination.usg1 = "non-pregnant";
                //   animal.lastSemination.usg2 = "non-pregnant";
                // }

                if (!animal.lastSemination) {
                  animal.lastSemination = { usg1: "open", usg2: "open" };
                } else if (
                  animal.lastBirth &&
                  animal.lastSemination &&
                  animal.lastBirth.date > animal.lastSemination.date
                ) {
                  animal.lastSemination.usg1 = "open";
                  animal.lastSemination.usg2 = "open";
                }

                if (animal.gender === "male") {
                  animal.lastSemination = { usg1: "", usg2: "" };
                }

                let mappedAnimal = {} as any;
                value.columns.forEach((formColumn: string) => {
                  mappedAnimal[columns[formColumn]] = getNestedValue(
                    animal,
                    formColumn,
                  );
                });

                return mappedAnimal;
              });

            const worksheet = XLSX.utils.json_to_sheet(data);
            worksheet["!cols"] = Object.keys(data[0]).map(() => ({ wch: 15 }));
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Rapor");
            const excelBuffer = XLSX.write(workbook, {
              bookType: "xlsx",
              type: "array",
            });
            const blob = new Blob([excelBuffer], {
              type: "application/octet-stream",
            });
            saveAs(blob, (props.companyName ?? "") + " Sürü Raporu.xlsx");
            setReportLoading(false);
          });
        }}
      >
        <Form form={reportForm} layout="vertical">
          <Form.Item
            style={{ marginBottom: 0 }}
            label="Kolonlar"
            name="columns"
            rules={[Rules.required]}
          >
            <Select
              style={{ width: "100%" }}
              mode="multiple"
              options={Object.keys(columns).map((column) => ({
                label: columns[column],
                value: column,
              }))}
            />
          </Form.Item>
          <Row justify="space-between" align="middle">
            <Checkbox
              checked={isDeadInclude}
              onChange={(e) => setIsDeadInclude(e.target.checked)}
            >
              Sürüden Çıkmışlarıda Ekle
            </Checkbox>
            <div>
              <Button
                style={{ margin: 0, padding: 0 }}
                type="link"
                onClick={() => reportForm.setFieldValue("columns", [])}
                danger
              >
                Tümünü Kaldır
              </Button>
              <Button
                style={{ margin: 0 }}
                type="link"
                onClick={() =>
                  reportForm.setFieldValue("columns", Object.keys(columns))
                }
              >
                Tümünü Seç
              </Button>
            </div>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AnimalExcelReportModal;
